import React from 'react';
import { ShieldCheckIcon, ServerIcon, LockIcon } from 'lucide-react';
export function SecuritySection() {
  return <section className="py-20 bg-white" data-id="element-159">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-160">
        <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-161">
          <h2 id="compliance" className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6" data-id="element-162">
            100% DSGVO – 100% Made in Germany – 0% externes KI-Risiko
          </h2>
        </div>
        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-163">
          <div className="bg-green-50 rounded-xl p-8 border-2 border-green-200" data-id="element-164">
            <ShieldCheckIcon className="w-12 h-12 text-green-600 mb-4" data-id="element-165" />
            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-166">
              Datensicherheit
            </h3>
            <p className="text-gray-700 mb-4" data-id="element-167">
              Legallama läuft ausschließlich auf unseren eigenen Servern in
              Deutschland. Keine Cloud-Dienste. Keine Auslandsübertragung. Keine
              US-Anbieter.
            </p>
            <p className="text-gray-900 font-semibold" data-id="element-168">
              Ihre Mandatsdaten bleiben zu jeder Zeit vollständig in Ihrer
              Hoheit.
            </p>
          </div>
          <div className="bg-blue-50 rounded-xl p-8 border-2 border-blue-200" data-id="element-169">
            <ServerIcon className="w-12 h-12 text-blue-600 mb-4" data-id="element-170" />
            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-171">
              Lokale KI-Modelle
            </h3>
            <p className="text-gray-700 mb-4" data-id="element-172">
              Alle LLMs, Automatisierungslogiken und KI-Module laufen lokal auf
              unserer eigenen Serverinfrastruktur. Es findet bei der Nutzung von
              KI keinerlei Datentransfer an Dritte statt.
            </p>
            <p className="text-gray-900 font-semibold" data-id="element-173">
              Unsere juristisch trainierten Modelle wurden speziell für
              verkehrsrechtliche Vorgänge entwickelt – sicher, präzise,
              compliant.
            </p>
          </div>
          <div className="bg-purple-50 rounded-xl p-8 border-2 border-purple-200" data-id="element-174">
            <LockIcon className="w-12 h-12 text-purple-600 mb-4" data-id="element-175" />
            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-176">
              Rechtskonforme Architektur
            </h3>
            <ul className="space-y-2 text-gray-700" data-id="element-177">
              <li data-id="element-178">✓ Ende-zu-Ende-verschlüsselt</li>
              <li data-id="element-179">✓ Zero-Trust-Architektur</li>
              <li data-id="element-180">✓ Revisionssichere Protokollierung</li>
              <li data-id="element-181">✓ Hosting in deutschen ISO-zertifizierten Rechenzentren</li>
              <li data-id="element-182">✓ Entwickelt und betrieben durch Legallama</li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}